import React, { lazy, Suspense, useLayoutEffect } from 'react'
import { Routes, BrowserRouter, Route, useLocation } from 'react-router-dom';
import Layout from './layouts';
import HomePage from './pages/home';

const routes = [
  // STRUKTUR PERUSAHAAN
  {
    path: '/profil-perusahaan',
    Component: lazy(() => import('./pages/about/ProfilPerusahaan')),
    exact: true,
  },
  // TATA KELOLA
  {
    path: '/tata-kelola/piagam',
    Component: lazy(() => import('./pages/TataKelola/piagam')),
    exact: true,
  },
  {
    path: '/tata-kelola/rups',
    Component: lazy(() => import('./pages/TataKelola/rups')),
    exact: true,
  },
  // STRUKTUR PERUSAHAAN
  {
    path: '/struktur-perusahaan',
    Component: lazy(() => import('./pages/about/structure/DewanKomisaris')),
    exact: true,
  },
  {
    path: '/struktur-perusahaan/dewan-komisaris',
    Component: lazy(() => import('./pages/about/structure/DewanKomisaris')),
    exact: true,
  },
  {
    path: '/struktur-perusahaan/dewan-komisaris/:detail',
    Component: lazy(() => import('./pages/about/structure/DewanKomisaris')),
    exact: true,
  },
  {
    path: '/struktur-perusahaan/direksi',
    Component: lazy(() => import('./pages/about/structure/DewanDireksi')),
    exact: true,
  },
  {
    path: '/struktur-perusahaan/direksi/:detail',
    Component: lazy(() => import('./pages/about/structure/DewanDireksi')),
    exact: true,
  },
  {
    path: '/struktur-perusahaan/struktur-organisasi',
    Component: lazy(() => import('./pages/about/structure/StrukturOrganisasi')),
    exact: true,
  },
  // USAHA KAMI
  {
    path: '/usaha-kami',
    Component: lazy(() => import('./pages/UsahaKami')),
    exact: true,
  },
  // KEPEDULIAN SOSIAL
  {
    path: '/kepedulian-sosial',
    Component: lazy(() => import('./pages/social')),
    exact: true,
  },
  // ARTIKEL
  {
    path: '/artikel',
    Component: lazy(() => import('./pages/artikel')),
    exact: true,
  },
  {
    path: '/artikel/:slug',
    Component: lazy(() => import('./pages/artikel/detail')),
    exact: true,
  },
  // HUBUNGAN INVESTOR
  {
    path: '/hubungan-investor/laporan-keuangan',
    Component: lazy(() => import('./pages/HubunganInvestor/LaporanKeuangan')),
    exact: true,
  },
  {
    path: '/hubungan-investor/prospektus',
    Component: lazy(() => import('./pages/HubunganInvestor/prospectus')),
    exact: true,
  },
  {
    path: '/hubungan-investor/laporan-tahunan',
    Component: lazy(() => import('./pages/HubunganInvestor/LaporanTahunan')),
    exact: true,
  },
  {
    path: '/hubungan-investor/infromasi-pemegang-saham',
    Component: lazy(() => import('./pages/HubunganInvestor/InformasiPemegangSaham')),
    exact: true,
  },
  {
    path: '/hubungan-investor/infromasi-saham',
    Component: lazy(() => import('./pages/HubunganInvestor/InformasiSaham')),
    exact: true,
  },
  {
    path: '/hubungan-investor/dividen',
    Component: lazy(() => import('./pages/HubunganInvestor/Dividen')),
    exact: true,
  },
  {
    path: '/hubungan-investor/investor-news',
    Component: lazy(() => import('./pages/HubunganInvestor/InvestorNews')),
    exact: true,
  },
  // KARIR
  {
    path: '/karir',
    Component: lazy(() => import('./pages/career')),
    exact: true,
  },
  // KONTAK
  {
    path: '/hubungi-kami',
    Component: lazy(() => import('./pages/contact')),
    exact: true,
  },
]

const Router = ({ history }) => {
  return (
    <BrowserRouter history={history}>
      <Layout>
        <ContentRoutes />
      </Layout>
    </BrowserRouter>
  );
}

const ContentRoutes = () => {
  const location = useLocation();
  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <Routes>
      <Route exact path="/" element={<HomePage />} />
      {routes.map(({ path, Component, exact }) => (
        <Route
          path={path}
          key={path}
          exact={exact}
          element={
            <Suspense fallback={null}>
              <Component />
            </Suspense>
          }
        />
      ))}
    </Routes>

  )
}

export default Router;